module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-card"
  }, [_vm._m(0), _c('div', {
    ref: "birthdayScroll",
    staticClass: "birthday-scroll",
    on: {
      "&scroll": function($event) {
        return _vm.handleScroll($event)
      }
    }
  }, [(_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "initial-loading"
  }, [_c('div', {
    staticClass: "loader"
  }), _c('span', [_vm._v("Cargando cumpleaños...")])]) : (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._m(1), _vm._m(2)]) : [_vm._l((_vm.lista), function(o) {
    return _c('div', {
      key: o.id,
      staticClass: "birthday"
    }, [_c('div', {
      staticClass: "birthday-avatar"
    }, [_c('img', {
      attrs: {
        "src": o.pathFoto
      },
      on: {
        "error": _vm.imagenDefault
      }
    })]), _c('div', {
      staticClass: "birthday-info"
    }, [_c('strong', [_vm._v(_vm._s(o.nombre))]), _c('span', [_vm._v(_vm._s(o.nombreArea))])])])
  }), (_vm.isScroll) ? _c('div', {
    staticClass: "scroll-loading"
  }, [_c('div', {
    staticClass: "loader loader-small"
  }), _c('span', [_vm._v("Cargando más cumpleaños...")])]) : _vm._e(), (_vm.noMore && _vm.lista.length > 0) ? _c('div', {
    staticClass: "scroll-end"
  }, [_c('span', [_vm._v("No hay más cumpleaños")])]) : _vm._e()]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("🎂 Cumpleaños de hoy")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-circle"
  }, [_c('span', [_vm._v("🎂")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-info"
  }, [_c('strong', [_vm._v("Sin cumpleaños hoy")]), _c('p', [_vm._v("No existen colaboradores cumpliendo años.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71599ef3","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/dashboard/c_cumpleanios_hoy.vue
// module id = 904
// module chunks = 0